/* Linsoul reviews band: endless drift (eases to a stop under the mouse), arrows, "Read more" on clamped quotes. */
(() => {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const EASE = 0.45; /* seconds to reach ~63% of the target speed */

  function init(root) {
    if (root.dataset.lsrvReady) return;
    root.dataset.lsrvReady = '1';
    const rail = root.querySelector('[data-lsrv-rail]');
    const nav = root.querySelector('[data-lsrv-nav]');
    const prev = root.querySelector('[data-lsrv-prev]');
    const next = root.querySelector('[data-lsrv-next]');
    if (!rail) return;

    const speed = parseFloat(root.dataset.lsrvSpeed) || 0;
    const inEditor = !!(window.Shopify && Shopify.designMode);
    const drift = speed > 0 && !inEditor;
    const cards = [...rail.children];

    const max = () => rail.scrollWidth - rail.clientWidth;
    const step = () => {
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return cards[0] ? cards[0].getBoundingClientRect().width + gap : rail.clientWidth;
    };

    /* Clones after the last card so the loop has no visible seam. */
    let clones = [];
    let loopW = 0;
    const buildClones = () => {
      clones.forEach((c) => c.remove());
      clones = [];
      loopW = 0;
      if (!drift || cards.length < 2) return;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      const total = cards.reduce((w, c) => w + c.getBoundingClientRect().width + gap, 0);
      if (total - gap <= rail.clientWidth + 2) return;
      let filled = 0;
      for (const card of cards) {
        if (filled > rail.clientWidth + step()) break;
        const c = card.cloneNode(true);
        c.classList.remove('is-open');
        c.setAttribute('aria-hidden', 'true');
        c.dataset.lsrvClone = '';
        c.removeAttribute('data-shopify-editor-block');
        c.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        c.querySelectorAll('[aria-controls]').forEach((el) => el.removeAttribute('aria-controls'));
        c.querySelectorAll('a,button').forEach((el) => el.setAttribute('tabindex', '-1'));
        const more = c.querySelector('[data-lsrv-more]');
        if (more) { more.setAttribute('aria-expanded', 'false'); if (more.dataset.more) more.textContent = more.dataset.more; }
        rail.appendChild(c);
        clones.push(c);
        filled += card.getBoundingClientRect().width + gap;
      }
      loopW = clones.length ? clones[0].offsetLeft - cards[0].offsetLeft : 0;
    };

    const update = () => {
      if (nav) nav.hidden = max() <= 2;
      if (prev) prev.disabled = !loopW && rail.scrollLeft <= 2;
      if (next) next.disabled = !loopW && rail.scrollLeft >= max() - 2;
    };

    /* Drift */
    let pos = 0;
    let lastSet = -1;
    let v = 0;
    let last = 0;
    let raf = 0;
    let hover = false;
    let focus = false;
    let visible = false;
    let holdUntil = 0;

    const anyOpen = () => !!rail.querySelector('.lsrv-card.is-open');
    const target = () => (hover || focus || anyOpen() || performance.now() < holdUntil || document.hidden || reduce.matches ? 0 : speed);
    const hold = (ms) => { holdUntil = performance.now() + ms; v = 0; start(); };

    const frame = (now) => {
      raf = 0;
      const dt = Math.min((now - (last || now)) / 1000, 0.1);
      last = now;
      if (Math.abs(rail.scrollLeft - lastSet) > 2) pos = rail.scrollLeft; /* someone scrolled */
      const t = target();
      v += (t - v) * (1 - Math.exp(-dt / EASE));
      if (t === 0 && v < 0.5) v = 0;
      if (v > 0 && loopW) {
        pos += v * dt;
        if (pos >= loopW) pos -= loopW;
        rail.scrollLeft = pos;
        lastSet = rail.scrollLeft;
      } else if (loopW && performance.now() >= holdUntil && rail.scrollLeft >= loopW) {
        pos = rail.scrollLeft - loopW;
        rail.scrollLeft = pos;
        lastSet = rail.scrollLeft;
      }
      if (visible && (v > 0 || t > 0 || performance.now() < holdUntil)) raf = requestAnimationFrame(frame);
      else last = 0;
    };
    const start = () => { if (drift && loopW && visible && !raf) raf = requestAnimationFrame(frame); };

    if (drift) {
      rail.classList.add('is-drifting');
      rail.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hover = true; });
      rail.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { hover = false; start(); } });
      rail.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) focus = true; });
      rail.addEventListener('focusout', () => { focus = false; start(); });
      rail.addEventListener('touchstart', () => hold(60000), { passive: true });
      rail.addEventListener('touchend', () => hold(2500), { passive: true });
      rail.addEventListener('wheel', (e) => { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) hold(1500); }, { passive: true });
      document.addEventListener('visibilitychange', start);
      reduce.addEventListener?.('change', start);
      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
        start();
      }).observe(rail);
    }

    const go = (dir) => {
      hold(1200);
      if (dir < 0 && loopW && rail.scrollLeft < step() - 2) {
        rail.scrollLeft += loopW;
        pos = rail.scrollLeft;
      }
      rail.scrollBy({ left: dir * step(), behavior: reduce.matches ? 'auto' : 'smooth' });
    };
    prev?.addEventListener('click', () => go(-1));
    next?.addEventListener('click', () => go(1));
    rail.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });

    const clamp = () => {
      rail.querySelectorAll('.lsrv-card').forEach((card) => {
        const quote = card.querySelector('[data-lsrv-quote]');
        const more = card.querySelector('[data-lsrv-more]');
        if (!quote || !more || card.classList.contains('is-open')) return;
        more.hidden = quote.scrollHeight <= quote.clientHeight + 2;
      });
    };
    root.addEventListener('click', (e) => {
      const more = e.target.closest('[data-lsrv-more]');
      if (!more) return;
      const card = more.closest('.lsrv-card');
      const open = !card.classList.contains('is-open');
      card.classList.toggle('is-open', open);
      more.setAttribute('aria-expanded', String(open));
      if (!more.dataset.more) more.dataset.more = more.textContent;
      more.textContent = open ? more.dataset.less : more.dataset.more;
      update();
      start();
    });

    let width = 0;
    new ResizeObserver(() => {
      if (rail.clientWidth !== width) {
        width = rail.clientWidth;
        clamp();
        buildClones();
        clamp();
      }
      update();
      start();
    }).observe(rail);
  }

  const run = () => document.querySelectorAll('[data-lsrv]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
